import React, { FC, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { ConfirmationModal } from 'transfix-ui/components/Modals'
import { deleteChildUser } from 'utils/actions/user'
import { IChildUserState } from 'utils/reducers/childUsers'
import { IChildUser } from 'apps/user/types/user'

interface IDeleteUserAccountModalProps {
  closeModalHandler: () => void
  showModal: boolean
  user: IChildUser
}

interface IStore {
  childUsers: IChildUserState
}

export const DeleteUserAccountModal: FC<IDeleteUserAccountModalProps> = ({
  closeModalHandler,
  showModal: showDeleteModal,
  user,
}) => {
  const dispatch = useDispatch()

  const { error, fetching, users } = useSelector<IStore, IChildUserState>(({ childUsers }) => ({
    ...childUsers,
  }))

  useEffect(() => {
    if (showDeleteModal) {
      const userDeleted = !users.find(savedUser => savedUser.id === user.id)

      if (userDeleted) closeModalHandler()
    }
  }, [showDeleteModal, users])

  const deleteUser = (): void => {
    dispatch(deleteChildUser(user))
  }

  return (
    <ConfirmationModal
      title='Delete carrier account?'
      size={4}
      open={showDeleteModal}
      actions={[
        { label: 'Cancel', type: 'dismiss', disabled: fetching },
        {
          label: 'Delete Account',
          type: 'confirm',
          action: deleteUser,
          disabled: fetching,
          dataTest: 'delete-user',
        },
      ]}
      onClose={closeModalHandler}
      dataTest='delete-user-account'
      error={error}>
      <p>
        This user will no longer be able to access this carrier’s account on the Transfix web app or
        mobile app.
      </p>
    </ConfirmationModal>
  )
}
